// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IsHcpIntakeAllowedResponseModel {
    static getAttributeTypeMap() {
        return IsHcpIntakeAllowedResponseModel.attributeTypeMap;
    }
}
IsHcpIntakeAllowedResponseModel.discriminator = undefined;
IsHcpIntakeAllowedResponseModel.additionalProperties = false;
IsHcpIntakeAllowedResponseModel.attributeTypeMap = [
    {
        "name": "isIntakeAllowed",
        "baseName": "isIntakeAllowed",
        "type": "boolean"
    },
    {
        "name": "reasonsNotAllowed",
        "baseName": "reasonsNotAllowed",
        "type": ""
    },
];
//# sourceMappingURL=isHcpIntakeAllowedResponseModel.js.map